export const ZENDESK_FEEDBACK_ACCESS_TOKEN_KEY = 'ZENDESK_FEEDBACK_ACCESS_TOKEN';

export const ZENDESK_HC_ACCESS_TOKEN_KEY = 'ZENDESK_HC_ACCESS_TOKEN';
